export default __webpack_public_path__ + "static/media/bank (1).1ecb0530.svg";